import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";
import { getForm, getParams, getStatus } from "../../redux/selector";
import { isNotEmpty } from "../../Utils";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

function Form075SubmittedDialog({ formOpen, onConfirm, referenceNumber = "" }) {
    const { t, i18n } = useTranslation();
    const status = useSelector(getStatus());
    const form = useSelector(getForm());
    const params = useSelector(getParams());
    const formNumber = Number(params?.formNumber);
    const schoolyear = formNumber - 1 + "/" + params?.formNumber?.slice(2);
    const isGovernment = form.schlfinanceTpends?.trim() === "GOVERNMENT";
    let toAppro = false;
    if (status >= 0 && status <= 8) {
        toAppro = true;
    }

    return (
        <React.Fragment>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={formOpen}
            >
                <DialogTitle id="simple-dialog-title">
                    <span
                        dangerouslySetInnerHTML={{
                            __html:
                                status === 1
                                    ? t(
                                          "common.portal.successfulFormSubmissionFirstForForm075"
                                      )
                                    : t(
                                          "common.portal.successfulFormSubmissionSecondForForm075"
                                      ),
                        }}
                    ></span>
                </DialogTitle>
                <DialogContent>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: isGovernment
                                ? t(
                                      `Form075.label.beforePrintIsGovernmentSchool`
                                  )
                                : t(
                                      `Form075.label.beforePrintIsNotGovernmentSchool`
                                  ),
                        }}
                    ></span>
                    <br />
                    <br />
                    {toAppro ? (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: t("Form075.label.printPdfTips", {
                                    schoolyear: schoolyear,
                                    note:
                                        i18n.language === "en"
                                            ? params.noteEn
                                            : params.noteTc,
                                }),
                            }}
                        ></span>
                    ) : (
                        t("common.portal.successfulSubmissionMsg1")
                    )}
                    <br />
                    <br />
                    {t("common.portal.successfulSubmissionMsg2")}
                    <br />
                    <br />
                    {isGovernment
                        ? t(`Form075.label.beforeRefIsGovernmentSchool`)
                        : t(`Form075.label.beforeRefIsNotGovernmentSchool`)}
                    <br />
                    <br />
                    {isNotEmpty(referenceNumber) &&
                        `${t(
                            "common.portal.referenceNum"
                        )}: ${referenceNumber}`}
                    <br />
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={onConfirm} color="success">
                        <b>{t("common.portal.close")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default Form075SubmittedDialog;
